import { collection, doc, getDoc, getDocs, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { getCollection } from "./data"

export default class Activity
{
	static async deleteAndUpdate(selection,activities,setActivities)
	{
		activities = activities.filter( project=>{
			const key = project.id;
			if(selection.includes(key))
			{
				const activityRef = doc(db, "Activity", key);
				deleteDoc(activityRef);
				return false;
			}
			return true;
		});
		setActivities(activities);
	}
}